var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Datepicker',{attrs:{"placeholder":'00/00/00',"format":'dd/MM/yy'},on:{"selected":function (value) { return _vm.handleChange(value); }},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }